import React from 'react'
import styles from "./chooseCatalog.module.css"
import { Button } from '../../ui/button/Button'
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout'
export function ChooseCatalog({ setCatalog, catalog }) {


    return (
        <section className={styles.choose_catalog}>
            <picture className={styles.background_holder}>
                <img loading='lazy' className={styles.background_img} src="/images/catalogBackground.webp" alt="catalog" />
            </picture>
            <MarkupLayout>
                <div className={styles.heading_holder}>

                    <h1 className={styles.heading_h1}>Каталог</h1>
                    <p className={styles.heading_description}>Всегда точный подбор</p>

                </div>

                <div className={styles.button_holder}>
                    <Button disabled={catalog === `brand` ? true : null} onClick={() => setCatalog("brand")} variant={"white"}>По марке автомобиля</Button>
                    <Button disabled={catalog === `article` ? true : null} onClick={() => setCatalog("article")} variant={"white"}>По артикулу (OEM или аналог)</Button>

                </div>
                <img className={styles.choose_catalog__img} width={165} height={55} src="/images/tecDoc.png" alt="TecAlliance" />
            </MarkupLayout>
        </section>
    )
}
